import request from '@/utils/request'

export const getTableData = params =>
  request.post('/customer-api/scorecard/page', params)
// 获取FRisk
export const getFRisk = (id, year) =>
  request.get(`/customer-api/score/${id}/frisk/${year}`)
// 选择 SC09 查询
export const getInfo09 = id => request.get(`/customer-api/customer/query/${id}`)

export const calcScoreCard = params =>
  request.post('/customer-api/scorecard/calculate', params)

export const getCardModelDetail = id =>
  request.get(`/customer-api/scorecard/view-model/${id}`)

export const getCardResultDetail = id =>
  request.get(`/customer-api/scorecard/view-result/${id}`)
// getLimitDetail
export const getLimitDetail = companyId =>
  request.get(`/customer-api/score/${companyId}/limit/detail`)
// 获取Lenovo Public Model Scorecard必填值
export const getThreeValue = (id, year) =>
  request.get(`/customer-api/company-finances/getThreeValue/${id}/${year}`)

export const getCompanyInfo = id =>
  request.get(`/customer-api/customer/overview/${id}`)

export const getCurrenyRate = (date, currencyA) =>
  request.get(`/customer-api/customer/${date}/${currencyA}/to/USD`)
